export default __webpack_public_path__ + "static/bg3-h-fd5ccb09ebcf3042012e140a81ceab7a.jpg";